/* eslint-disable */
import { useAuctionStore } from "@/stores/AuctionStore";
import _, { isObject } from "lodash";
import { ref, watch } from "vue";
const translations = ref<any>();
const watchInit = ref(false);

export function trans(key: string, values: Record<string, string | number> | null = null) {
  if (!translations.value) {
    const auctionStore = useAuctionStore();
    translations.value = auctionStore.translations;
  }

  if (!watchInit.value) {
    const auctionStore = useAuctionStore();
    watch(() => auctionStore.translations, () => {
      translations.value = auctionStore.translations;
    }, { deep: true });
    watchInit.value = true;
  }

  let result = _.get(translations.value, key, key);

  if (values && isObject(values)) {
    Object.entries(values).forEach(([key, value]) => {
      result = result.replaceAll(`:${key}`, value);
    });
  }

  return result;
}
